import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import PageDataContext from "@core/Context/PageDataContext";
import SourceData from "@ext/storage/logic/SourceDataProvider/model/SourceData";
import { useCallback, useEffect } from "react";
import { useValidateSource, type ValidateSourceFn } from "./useValidateSource";

const findInvalidSources = async (
	pageData: PageDataContext,
	validateSource: ValidateSourceFn,
): Promise<SourceData[]> => {
	const promises = pageData.sourceDatas.map(validateSource);
	await Promise.all(promises);

	return [...pageData.sourceDatas];
};

const useFindInvalidSources = () => {
	const validateSource = useValidateSource();
	const pageData = PageDataContextService.value;
	const pageDataRef = PageDataContextService.ref;

	return useCallback(async () => {
		const sourceDatas = await findInvalidSources(pageDataRef.value, validateSource);
		pageDataRef.value.sourceDatas = sourceDatas;
		PageDataContextService.value = pageDataRef.value;
	}, [pageData, validateSource]);
};

const useFindInvalidSouresOnStart = (isFirstLoad: boolean) => {
	const findInvalidSources = useFindInvalidSources();

	useEffect(() => {
		if (!isFirstLoad) return;
		findInvalidSources();
	}, [findInvalidSources, isFirstLoad]);
};

export { useFindInvalidSources, useFindInvalidSouresOnStart };
